import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/useIsMobile';
import { getSettingsItems, getSettingsCategories } from '@/lib/settingsItems';

export function Settings() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const settingsItems = getSettingsItems();
  const categories = getSettingsCategories();

  // Group items by category
  const groupedItems = {
    general: settingsItems.filter(item => item.category === 'general'),
    integrations: settingsItems.filter(item => item.category === 'integrations'),
    advanced: settingsItems.filter(item => item.category === 'advanced'),
  };

  if (isMobile) {
    return (
      <div className="px-4 py-5 space-y-6">
        {/* General */}
        <div>
          <h2 className="px-1 mb-3 text-xs font-medium text-muted-foreground uppercase tracking-wider">
            {categories.general}
          </h2>
          <div className="bg-card rounded-xl border divide-y">
            {groupedItems.general.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  className="flex items-center gap-3 w-full p-4 text-left active:bg-muted/50 transition-colors first:rounded-t-xl last:rounded-b-xl"
                  onClick={() => navigate(item.href)}
                >
                  <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10">
                    <Icon className="h-4 w-4 text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium">{item.title}</div>
                    <div className="text-xs text-muted-foreground line-clamp-1">{item.description}</div>
                  </div>
                  <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                </button>
              );
            })}
          </div>
        </div>

        {/* Integrations */}
        <div>
          <h2 className="px-1 mb-3 text-xs font-medium text-muted-foreground uppercase tracking-wider">
            {categories.integrations}
          </h2>
          <div className="bg-card rounded-xl border divide-y">
            {groupedItems.integrations.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  className="flex items-center gap-3 w-full p-4 text-left active:bg-muted/50 transition-colors first:rounded-t-xl last:rounded-b-xl"
                  onClick={() => navigate(item.href)}
                >
                  <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10">
                    <Icon className="h-4 w-4 text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium">{item.title}</div>
                    <div className="text-xs text-muted-foreground line-clamp-1">{item.description}</div>
                  </div>
                  <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                </button>
              );
            })}
          </div>
        </div>

        {/* Advanced */}
        <div>
          <h2 className="px-1 mb-3 text-xs font-medium text-muted-foreground uppercase tracking-wider">
            {categories.advanced}
          </h2>
          <div className="bg-card rounded-xl border divide-y">
            {groupedItems.advanced.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  className="flex items-center gap-3 w-full p-4 text-left active:bg-muted/50 transition-colors first:rounded-t-xl last:rounded-b-xl"
                  onClick={() => navigate(item.href)}
                >
                  <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10">
                    <Icon className="h-4 w-4 text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium">{item.title}</div>
                    <div className="text-xs text-muted-foreground line-clamp-1">{item.description}</div>
                  </div>
                  <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // Desktop - redirects are handled by SettingsLayout, but render something just in case
  return null;
}

export default Settings;
